import { call, put, takeLatest } from "redux-saga/effects"
import {
  FETCH_INVOICE_COMPANIES,
  CREATE_INVOICE_COMPANY,
  UPDATE_INVOICE_COMPANY,
  DELETE_INVOICE_COMPANY,
  TEST_INVOICE_COMPANY_AADE,
  TEST_INVOICE_COMPANY_EPSILON,
} from "./actionTypes"
import {
  fetchInvoiceCompaniesSuccess,
  fetchInvoiceCompaniesFail,
  createInvoiceCompanySuccess,
  createInvoiceCompanyFail,
  updateInvoiceCompanySuccess,
  updateInvoiceCompanyFail,
  deleteInvoiceCompanySuccess,
  deleteInvoiceCompanyFail,
  testInvoiceCompanyAadeSuccess,
  testInvoiceCompanyAadeFail,
  testInvoiceCompanyEpsilonSuccess,
  testInvoiceCompanyEpsilonFail,
} from "./actions"
import {
  getInvoiceCompanies,
  createInvoiceCompany,
  updateInvoiceCompany,
  deleteInvoiceCompany,
  testInvoiceCompanyAade,
  testInvoiceCompanyEpsilon,
} from "helpers/api_helper"

function* fetchInvoiceCompaniesSaga() {
  try {
    const companies = yield call(getInvoiceCompanies)
    yield put(fetchInvoiceCompaniesSuccess(companies))
  } catch (error) {
    yield put(fetchInvoiceCompaniesFail(error.message))
  }
}

function* createInvoiceCompanySaga(action) {
  try {
    const data = action.payload
    const result = yield call(createInvoiceCompany, data)
    yield put(createInvoiceCompanySuccess(result))
  } catch (error) {
    yield put(createInvoiceCompanyFail(error.message))
  }
}

function* updateInvoiceCompanySaga(action) {
  try {
    const { id, data } = action.payload
    const result = yield call(updateInvoiceCompany, id, data)
    yield put(updateInvoiceCompanySuccess(result))
  } catch (error) {
    yield put(updateInvoiceCompanyFail(error.message))
  }
}

function* deleteInvoiceCompanySaga(action) {
  try {
    const { id, hard } = action.payload
    yield call(deleteInvoiceCompany, id, hard)
    yield put(deleteInvoiceCompanySuccess(id))
  } catch (error) {
    yield put(deleteInvoiceCompanyFail(error.message))
  }
}

function* testInvoiceCompanyAadeSaga(action) {
  try {
    const id = action.payload
    const result = yield call(testInvoiceCompanyAade, id)
    yield put(testInvoiceCompanyAadeSuccess(result))
  } catch (error) {
    yield put(testInvoiceCompanyAadeFail(error.message))
  }
}

function* testInvoiceCompanyEpsilonSaga(action) {
  try {
    const id = action.payload
    const result = yield call(testInvoiceCompanyEpsilon, id)
    yield put(testInvoiceCompanyEpsilonSuccess(result))
  } catch (error) {
    yield put(testInvoiceCompanyEpsilonFail(error.message))
  }
}

function* invoiceCompaniesSaga() {
  yield takeLatest(FETCH_INVOICE_COMPANIES, fetchInvoiceCompaniesSaga)
  yield takeLatest(CREATE_INVOICE_COMPANY, createInvoiceCompanySaga)
  yield takeLatest(UPDATE_INVOICE_COMPANY, updateInvoiceCompanySaga)
  yield takeLatest(DELETE_INVOICE_COMPANY, deleteInvoiceCompanySaga)
  yield takeLatest(TEST_INVOICE_COMPANY_AADE, testInvoiceCompanyAadeSaga)
  yield takeLatest(TEST_INVOICE_COMPANY_EPSILON, testInvoiceCompanyEpsilonSaga)
}

export default invoiceCompaniesSaga
